import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ServiceaftaleDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceaftale-dto';
import { GetPriceServiceaftaleResponseDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/get-price-serviceaftale-response-dto';
import { FastprisaftaleService, HenviserService, PriceService, ServiceAftaleService } from 'src/app/api/services';
import { finalize, takeUntil, tap } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { AmountDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/amount-dto';
import { MatDialog } from '@angular/material/dialog';
import { FastprisaftaleDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/fastprisaftale-dto';
import { FastprisaftaleUpdateDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/fastprisaftale-update-dto';
import { FastprisaftaleCreateDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/fastprisaftale-create-dto';
import { AnlaegDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/anlaeg-dto';
import {
  EditPartnerDialogData,
  EditTilvalgDialogData,
  FastForwardOpkraevningsdateDialogData,
  FastPrisAddEditDialogData,
  OpkraevningsDialogData,
  OpkraevningsDialogResponse,
  PriceDialogData,
  RabatEditDialogData,
  ServiceintervallerDialogData,
} from '../../models';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Router } from '@angular/router';
import { ServiceaftaleTagDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceaftale-tag-dto';
import { ServiceaftaleUpdateResponseDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceaftale-update-response-dto';
import { AuthService } from 'src/app/services/auth.service';
import { FastprisAddEditComponent } from './fastpris-add-edit/fastpris-add-edit.component';
import { RabatAddEditComponent } from './rabat-add-edit/rabat-add-edit.component';
import { dkCurrencyPipe } from '../../../../pipes/dk-currency';
import { ConfirmDialogComponent } from 'src/app/components/shared/confirm-dialog/confirm-dialog.component';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { LoaderService } from 'src/app/services/loader.service';
import { ServiceaftaleDatesUpdateDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceaftale-dates-update-dto';
import { ServiceintervalerDialogComponent } from '../serviceintervaller/serviceintervaler-dialog/serviceintervaler-dialog.component';
import { EftersynStateEnum } from 'src/app/api/models/OK/Egis/Service/Models/DTO/Enums/eftersyn-state-enum';
import { OpkraevningStateEnum } from 'src/app/api/models/OK/Egis/Service/Models/DTO/Enums/opkraevning-state-enum';
import { PriceComponentDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/price-component-dto';
import { PriceDialogComponent } from '../../price-dialog/price-dialog.component';
import { OpkraevningsIntervalDialogComponent } from '../../create/forms/abonnement-form/opkraevnings-interval-dialog/opkraevnings-interval-dialog.component';
import { OpkraevningDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/opkraevning-dto';
import { HenviserDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/henviser-dto';
import { TilvalgGroupDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/tilvalg-group-dto';
import { UpcomingChangesDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/upcoming-changes-dto';
import { UpcomingChangesDialogComponent } from '../upcoming-changes-dialog/upcoming-changes-dialog.component';
import { UpcomingChangesDialogData } from '../upcoming-changes-dialog/upcoming-changes-dialog.data';
import { FastForwardOpkraevningsdateDialogComponent } from './fast-forward-opkraevningsdate-dialog/fast-forward-opkraevningsdate-dialog.component';
import { EditPartnerComponent } from '../../edit-partner/edit-partner.component';
import { EditServiceabonnementTilvalgDialogComponent } from 'src/app/components/tilvalg/edit-serviceabonnement-tilvalg-dialog/edit-serviceabonnement-tilvalg-dialog.component';
import { PartnerDialogComponent } from 'src/app/components/shared/partner-dialog/partner-dialog.component';
import { ServiceaftaleStateEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/serviceaftale-state-enum';
import { StamdataStatusEnum } from '../../../../api/models/OK/Egis/Service/Models/Entities/Enums/stamdata-status-enum';
import { ServiceAgreementStateService } from 'src/app/services/serviceAgreementState.service';
import { UpdateOpkraevningsintervalRequest } from 'src/app/api/models/OK/Egis/Service/Models/Request/update-opkraevningsinterval-request';
import { ChangeEffect } from 'src/app/api/models/OK/Egis/Service/Models/Request/change-effect';

@Component({
  selector: 'app-abonnement',
  templateUrl: './abonnement.component.html',
  styleUrls: ['./abonnement.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AbonnementComponent implements OnInit {
  private _serviceaftale: ServiceaftaleDto;

  serviceaftaleStateEnum: typeof ServiceaftaleStateEnum = ServiceaftaleStateEnum;

  eftersynStateEnum = EftersynStateEnum;
  opkraevningStateEnum = OpkraevningStateEnum;

  @Input() set serviceaftale(value: ServiceaftaleDto) {
    this._serviceaftale = value;

    this.updateView();
  }

  @Input() tilvalgGroups: TilvalgGroupDto[];

  get serviceaftale(): ServiceaftaleDto {
    return this._serviceaftale;
  }

  @Output() serviceaftaleChanged: EventEmitter<ServiceaftaleDto> = new EventEmitter();
  @Output() reactivateServiceAgreement: EventEmitter<void> = new EventEmitter();

  unsubscribe$ = new Subject<void>();

  today = new Date();
  totalPrice: AmountDto;
  basePrice: AmountDto;
  listPrice: AmountDto;
  fixedPriceActive: boolean = false;
  priceComponents: PriceComponentDto[];
  opkraevning: OpkraevningDto;
  rabatEnabled: boolean = false;
  isPrivatKunde: boolean = false;
  isOpsagt: boolean = false;
  isAdmin: boolean = false;
  isSuperUser: boolean = false;
  isCustomerService: boolean = false;
  canWrite: boolean = false;
  canEditAbonnement: boolean = false;
  canReactivate: boolean = false;
  isNaerVarme: boolean = false;
  isLeasing: boolean = false;
  isGasfyrTryghed: boolean = false;

  pricesWithoutMoms: boolean = false;
  activeColumns: string[] = ['startdate', 'enddate', 'fastpris', 'rowActions'];
  dataSource = new BehaviorSubject<FastprisaftaleDto[]>([]);

  rabatForm: UntypedFormGroup;
  g4Error: string;

  canEditFakturaStop: boolean = false;
  canEditNaesteEftersyn: boolean = false;
  canSeePriceInfo: boolean = false;
  canFastForward: boolean = false;

  tags: ServiceaftaleTagDto[];

  abonnementForm: UntypedFormGroup;
  notesForm: UntypedFormGroup;
  datoForm: UntypedFormGroup;
  henviserForm: UntypedFormGroup;

  henvisere: HenviserDto[] = [];

  henviserEditMode: boolean = false;

  upcomingChanges: UpcomingChangesDto;

  get serviceOrderNote() {
    return this.notesForm.get('serviceOrderNote');
  }

  get startDate() {
    return this.abonnementForm.get('startDate');
  }

  get naesteEftersynDate() {
    return this.abonnementForm.get('naesteEftersynDate');
  }

  get opkraevningDate() {
    return this.abonnementForm.get('opkraevningDate');
  }

  get fakturastop() {
    return this.abonnementForm.get('fakturastop');
  }

  get henviserCvr() {
    return this.henviserForm.get('henviserCvr');
  }

  constructor(
    private serviceAftaleService: ServiceAftaleService,
    private priceService: PriceService,
    private errorHandler: ErrorHandlerService,
    private fastPrisService: FastprisaftaleService,
    public dialog: MatDialog,
    private dkCurrencyPipe: dkCurrencyPipe,
    private router: Router,
    private auth: AuthService,
    private formBuilder: UntypedFormBuilder,
    private loader: LoaderService,
    private henviserService: HenviserService,
    private serviceAftaleStateService: ServiceAgreementStateService,
  ) {
    this.canWrite = this.auth.canWrite;
    this.isAdmin = this.auth.isAdministrator;
    this.isSuperUser = this.auth.isSuperuser;
    this.isCustomerService = this.auth.isKundeservice;
    this.canEditFakturaStop = this.auth.isSuperuser || this.auth.isAdministrator;
    this.canEditNaesteEftersyn = this.auth.isAdministrator || this.auth.isSuperuser;
    this.canSeePriceInfo = this.auth.isAdministrator || this.auth.isSuperuser;
    this.canEditAbonnement = this.auth.isAdministrator || this.auth.isSuperuser || this.auth.isKundeservice;
    this.canReactivate = this.auth.isAdministrator || this.auth.isSuperuser || this.auth.isKundeservice;
    this.canFastForward = this.auth.isAdministrator || this.auth.isSuperuser;

    this.abonnementForm = this.formBuilder.group({
      startDate: [null, Validators.required],
      naesteEftersynDate: [null, Validators.required],
      opkraevningDate: [null],
      fakturastop: [null],
    });
    this.notesForm = this.formBuilder.group({
      serviceOrderNote: [
        {
          value: null,
          disabled: this.isOpsagt,
        },
        Validators.maxLength(500),
      ],
    });
    this.henviserForm = this.formBuilder.group({
      henviserCvr: [null],
    });
  }

  ngOnInit(): void {
    this.henviserService
      .getHenvisere({
        caller: EGIS_SERVICE_CALLER,
        body: {
          searchQuery: null,
        },
      })
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (response: HenviserDto[]) => {
          this.henvisere = response.filter((p) => p.henviserStatus == StamdataStatusEnum.Yes);
        },
        (error) => {
          this.errorHandler.HandleError(error);
        },
      );

    this.henviserCvr.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.updateHenviser();
    });
  }

  updateView() {
    this.isOpsagt = this.serviceaftale.serviceaftaleState.state == ServiceaftaleStateEnum.Terminated;
    this.isNaerVarme = this.serviceaftale.kunde?.kundeExtendedInformation?.harNaervarmeAftale;
    this.isLeasing = this.serviceaftale.kunde?.kundeExtendedInformation?.harLeasingAftale;
    this.isGasfyrTryghed = this.serviceaftale.kunde?.kundeExtendedInformation?.harGasfyrTryghedAftale;

    this.today.setHours(0, 0, 0, 0);

    this.serviceOrderNote.patchValue(this.serviceaftale.naesteEftersynDescription, {
      emitEvent: false,
    });
    if (this.isOpsagt) {
      this.serviceOrderNote.disable();
    }
    this.startDate.patchValue(this.serviceaftale.startDate, {
      emitEvent: false,
    });

    this.naesteEftersynDate.patchValue(this.serviceaftale.naesteEftersynDate, {
      emitEvent: false,
    });
    this.opkraevningDate.patchValue(this.serviceaftale.opkraevningDate, {
      emitEvent: false,
    });
    this.fakturastop.patchValue(this.serviceaftale.fakturaStop, {
      emitEvent: false,
    });
    this.henviserCvr.patchValue(this.serviceaftale.henviser?.cvr, {
      emitEvent: false,
    });
    this.isPrivatKunde = this.serviceaftale.serviceAbonnement.kundeType.id == 1;
    this.rabatEnabled =
      this.serviceaftale.rabatKontantInclMoms != null ||
      this.serviceaftale.rabatKontantExclMoms != null ||
      this.serviceaftale.rabatProcent != null;

    this.serviceAftaleService
      .getUpcomingChanges({
        serviceaftaleId: this.serviceaftale.id,
        caller: EGIS_SERVICE_CALLER,
      })
      .subscribe((upcomingChanges: UpcomingChangesDto) => {
        this.upcomingChanges = upcomingChanges;
      });

    this.updatePrices();
    this.updateTableView();
  }

  updatePrices() {
    this.pricesWithoutMoms = false;
    this.basePrice = null;
    this.totalPrice = null;
    this.listPrice = null;
    this.fixedPriceActive = false;
    this.priceComponents = null;

    this.priceService
      .getPriceForServiceAftale({
        caller: EGIS_SERVICE_CALLER,
        serviceaftaleId: this.serviceaftale.id,
      })
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (price: GetPriceServiceaftaleResponseDto) => {
          this.pricesWithoutMoms = !price.preferredShownWithMoms;
          this.basePrice = price.basePrice;
          this.totalPrice = price.totalPrice;
          this.listPrice = price.listPrice;
          this.fixedPriceActive = price?.fastprisaftale?.fastprisaftaleState.id === 2; //Active
          this.priceComponents = price.priceComponents;
          this.opkraevning = price.opkraevning;
        },
        (error: HttpErrorResponse) => {
          if (error && error.error && error.error.code && error.error.code > 900000 && error.error.code < 1000000) {
            this.g4Error = error.error.message;
          }
        },
      );
  }

  updateTableView() {
    this.dataSource.next(this.serviceaftale.fastprisaftaler);
  }

  changeFakturastop(change: MatSlideToggleChange) {
    this.serviceAftaleService
      .fakturastop({
        caller: EGIS_SERVICE_CALLER,
        body: {
          fakturastop: this.fakturastop.value,
          serviceaftaleId: this.serviceaftale.id,
          rowVersion: this.serviceaftale.rowVersion,
        },
      })
      .subscribe(
        () => {
          this.serviceaftale.fakturaStop = change.checked;
        },
        (error) => {
          this.errorHandler.HandleError(error);
        },
      );
  }

  rabatChanged() {
    if (!this.rabatEnabled) {
      this.openRabatDialog();
    } else if (this.rabatEnabled) {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '600px',
        maxWidth: '95vw',
        data: {
          title: 'Er du sikker?',
          body: 'Er du sikker på at du vil slette rabatten',
        },
      });

      dialogRef.afterClosed().subscribe((confirm) => {
        if (confirm) {
          this.serviceAftaleService
            .removeRabat({
              caller: EGIS_SERVICE_CALLER,
              serviceaftaleId: this.serviceaftale.id,
            })
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
              (response: ServiceaftaleDto) => {
                this.serviceaftale = response;
                this.serviceaftaleChanged.emit(response);
                this.rabatEnabled = false;
                this.updatePrices();
              },
              (error: HttpErrorResponse) => {
                this.errorHandler.HandleError(error);
              },
            );
        }
      });
    }
  }

  openRabatDialog() {
    let data: RabatEditDialogData = {
      isPrivatKunde: this.isPrivatKunde,
      rabatKontant: this.isPrivatKunde ? this.serviceaftale.rabatKontantInclMoms : this.serviceaftale.rabatKontantExclMoms,
      rabatProcent: this.serviceaftale.rabatProcent,
      rabatTekst: this._serviceaftale.rabatTekst,
      rabatSplit: this._serviceaftale.partnerShare,
      serviceaftaleId: this.serviceaftale.id,
      maxRabatKontant: this.isPrivatKunde ? this.listPrice.withMoms : this.listPrice.withoutMoms,
      engangsRabat: this.serviceaftale.isEngangsRabat,
      rowVersion: this.serviceaftale.rowVersion,
    };

    const dialogRef = this.dialog.open(RabatAddEditComponent, {
      width: '600px',
      maxWidth: '95vw',
      data: data,
    });

    dialogRef.afterClosed().subscribe((result: ServiceaftaleDto) => {
      if (result) {
        this.serviceaftale = result;
        this.serviceaftaleChanged.emit(this.serviceaftale);
        this.rabatEnabled = true;
        this.updatePrices();
      }
    });
  }

  addFastpris() {
    let data: FastPrisAddEditDialogData = {
      fastprisAftale: null,
      editMode: false,
      existingFastpriser: this.serviceaftale.fastprisaftaler.slice(0),
      isPrivatKunde: this.isPrivatKunde,
    };

    const dialogRef = this.dialog.open(FastprisAddEditComponent, {
      width: '600px',
      maxWidth: '95vw',
      data: data,
    });

    dialogRef.afterClosed().subscribe((result: FastprisaftaleDto) => {
      if (result) {
        let startDateString = new Date(result.startDate).toDateString();
        let request: FastprisaftaleCreateDto = {
          endDate: result.endDate ? new Date(result.endDate).toOkDateString() : null,
          fastPrisExclMoms: result.fastPrisExclMoms,
          fastPrisInclMoms: result.fastPrisInclMoms,
          startDate: new Date(startDateString).toOkDateString(),
          serviceaftaleId: this.serviceaftale.id,
        };

        this.fastPrisService
          .create({ caller: EGIS_SERVICE_CALLER, body: request })
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(
            (response: FastprisaftaleDto) => {
              this.serviceaftale.fastprisaftaler.push(response);
              this.updateTableView();
            },
            (error: HttpErrorResponse) => {
              this.errorHandler.HandleError(error);
            },
          );
      }
    });
  }

  editFastprisAftale(aftale: FastprisaftaleDto) {
    let existingAftaler = this.serviceaftale.fastprisaftaler.slice(0).filter((x) => x.id != aftale.id);

    let data: FastPrisAddEditDialogData = {
      fastprisAftale: aftale,
      editMode: true,
      existingFastpriser: existingAftaler,
      isPrivatKunde: this.isPrivatKunde,
    };

    const dialogRef = this.dialog.open(FastprisAddEditComponent, {
      width: '600px',
      maxWidth: '95vw',
      data: data,
    });

    dialogRef.afterClosed().subscribe((result: FastprisaftaleDto) => {
      if (result) {
        const index: number = this.serviceaftale.fastprisaftaler.indexOf(aftale);
        if (index !== -1) {
          let request: FastprisaftaleUpdateDto = {
            endDate: result.endDate ? new Date(result.endDate).toOkDateString() : null,
            fastPrisExclMoms: result.fastPrisExclMoms,
            fastPrisInclMoms: result.fastPrisInclMoms,
            startDate: new Date(result.startDate).toOkDateString(),
            fastprisaftaleId: aftale.id,
          };

          this.fastPrisService
            .update({ caller: EGIS_SERVICE_CALLER, body: request })
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
              (response: FastprisaftaleDto) => {
                this.serviceaftale.fastprisaftaler[index] = response;
                this.updateTableView();
              },
              (error: HttpErrorResponse) => {
                this.errorHandler.HandleError(error);
              },
            );
        }
      }
    });
  }

  deleteFastprisAftale(aftale: FastprisaftaleDto) {
    let dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Er du sikker?',
        body:
          'Er du sikker på at du vil slette fastprisaftalen med prisen: ' +
          (this.isPrivatKunde ? aftale.fastPrisInclMoms : aftale.fastPrisExclMoms) +
          '?',
      },
    });

    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm) {
        this.fastPrisService
          .delete({ caller: EGIS_SERVICE_CALLER, fastprisaftaleId: aftale.id })
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(
            (response: FastprisaftaleDto[]) => {
              this.serviceaftale.fastprisaftaler = response;
              this.updateTableView();
            },
            (error: HttpErrorResponse) => {
              this.errorHandler.HandleError(error);
            },
          );
      }
    });
  }

  getDiscountTooltip(serviceaftale: ServiceaftaleDto) {
    let tooltips: Array<string> = [];

    if (this.fixedPriceActive) {
      let fastpris = this.isPrivatKunde ? this.totalPrice.withMoms : this.totalPrice.withoutMoms;
      tooltips.push('Fastpris på ' + this.dkCurrencyPipe.transform(fastpris) + ' aktiv');
    }
    if (serviceaftale.rabatProcent) {
      tooltips.push('Rabat på ' + serviceaftale.rabatProcent + ' % aktiv');
    } else if (serviceaftale.rabatKontantExclMoms || serviceaftale.rabatKontantInclMoms) {
      let rabat = this.isPrivatKunde ? serviceaftale.rabatKontantInclMoms : serviceaftale.rabatKontantExclMoms;
      tooltips.push('Rabat på ' + this.dkCurrencyPipe.transform(rabat) + ' aktiv');
    }

    return tooltips.join(' - ');
  }

  onAnlaegChanged(anlaeg: AnlaegDto) {
    this.serviceaftale.anlaeg = anlaeg;
    this.serviceaftaleChanged.emit(this.serviceaftale);
    this.updatePrices();
  }

  updateNotes() {
    if (!this.notesForm.valid || !this.notesForm.dirty) return;
    this.notesForm.markAsPristine();
    this.loader.show();
    this.serviceAftaleService
      .updateServiceOrdreNote({
        caller: EGIS_SERVICE_CALLER,
        body: {
          serviceaftaleId: this.serviceaftale.id,
          serviceEftersynNote: this.serviceOrderNote.value,
          rowVersion: this.serviceaftale.rowVersion,
        },
      })
      .pipe(
        tap(() => {}),
        finalize(() => {
          this.loader.hide();
        }),
        takeUntil(this.unsubscribe$),
      )
      .subscribe(
        () => {},
        (error) => {
          this.notesForm.markAsDirty();
          this.errorHandler.HandleError(error);
        },
      );
  }

  updateHenviser() {
    if (this.henviserCvr.value == this.serviceaftale.henviser?.cvr) {
      this.henviserEditMode = false;
      return;
    }
    this.loader.show();
    this.serviceAftaleService
      .updateServiceAftaleHenviser({
        caller: EGIS_SERVICE_CALLER,
        body: {
          henviserCvr: this.henviserCvr.value,
          serviceaftaleId: this.serviceaftale.id,
          rowVersion: this.serviceaftale.rowVersion,
        },
      })
      .pipe(
        finalize(() => {
          this.loader.hide();
          this.henviserEditMode = false;
        }),
        takeUntil(this.unsubscribe$),
      )
      .subscribe(
        (response) => {
          this.serviceaftale = response;
        },
        (error) => {
          this.errorHandler.HandleError(error);
        },
      );
  }

  onDateChange() {
    const prevStartDate = this.serviceaftale.startDate;
    const prevNaesteEftersynDate = this.serviceaftale.naesteEftersynDate;
    const prevOpkraevningDate = this.serviceaftale.opkraevningDate;

    const request: ServiceaftaleDatesUpdateDto = {
      naesteEftersynDate: this.naesteEftersynDate.value ? new Date(this.naesteEftersynDate.value).toOkDateString() : null,
      opkraevningDate: this.opkraevningDate.value ? new Date(this.opkraevningDate.value).toOkDateString() : null,
      startDate: this.startDate.value ? new Date(this.startDate.value).toOkDateString() : null,
      serviceaftaleNo: this.serviceaftale.serviceAftaleNo,
      rowVersion: this.serviceaftale.rowVersion,
    };

    this.loader.show();
    this.serviceAftaleService
      .updateServiceaftaleDates({
        caller: EGIS_SERVICE_CALLER,
        body: request,
      })
      .pipe(
        finalize(() => {
          this.loader.hide();
        }),
        takeUntil(this.unsubscribe$),
      )
      .subscribe(
        (result: ServiceaftaleUpdateResponseDto) => {
          this.serviceaftale = result.serviceaftale;
        },
        (error) => {
          this.errorHandler.HandleError(error);
          this.naesteEftersynDate.patchValue(prevNaesteEftersynDate);
          this.startDate.patchValue(prevStartDate);
          this.opkraevningDate.patchValue(prevOpkraevningDate);
        },
      );
  }

  async fastForwardOpkraevningsdate() {
    let opkraevningsDate = new Date(this.serviceaftale.opkraevningDate);
    let intervalWithOpkraevning = this.serviceaftale.serviceintervaller.find(
      (x) => new Date(x.startDate) <= opkraevningsDate && opkraevningsDate <= new Date(x.endDate),
    );

    let intervalStartDate = new Date(intervalWithOpkraevning?.startDate);
    let intervalEndDate = new Date(intervalWithOpkraevning?.endDate);

    let data: FastForwardOpkraevningsdateDialogData = {
      intervalStartDate: intervalStartDate,
      intervalEndDate: intervalEndDate,
      endDateInInterval: this.serviceaftale.endDate != null && new Date(this.serviceaftale.endDate) <= intervalEndDate,
    };

    const dlg = this.dialog.open<FastForwardOpkraevningsdateDialogComponent>(FastForwardOpkraevningsdateDialogComponent, { data: data });
    dlg.afterClosed().subscribe((remark: string) => {
      if (remark) {
        this.loader.show();
        this.serviceAftaleService
          .setOpkraevningsdatoToNextServiceinterval({
            caller: EGIS_SERVICE_CALLER,
            serviceaftaleId: this.serviceaftale.id,
            causeRemark: remark,
          })
          .pipe(
            finalize(() => {
              this.loader.hide();
            }),
            takeUntil(this.unsubscribe$),
          )
          .subscribe(
            (result: ServiceaftaleDto) => {
              this.serviceaftale = result;
              this.serviceaftaleChanged.emit(result);
            },
            (error) => {
              this.errorHandler.HandleError(error);
            },
          );
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  showServiceintervaller() {
    const data: ServiceintervallerDialogData = {
      serviceaftale: this.serviceaftale,
    };
    this.dialog.open(ServiceintervalerDialogComponent, {
      data: data,
      width: '800px',
    });
  }

  editPartner() {
    let data: EditPartnerDialogData = {
      serviceaftale: this.serviceaftale,
      upcomingChanges: this.upcomingChanges,
    };

    const dialogRef = this.dialog.open(EditPartnerComponent, {
      width: '600px',
      maxWidth: '95vw',
      data: data,
    });

    dialogRef.afterClosed().subscribe((result: ServiceaftaleDto) => {
      if (result) {
        this.serviceaftale = result;
        this.serviceaftaleChanged.emit(result);
      }
    });
  }

  editHenviser() {
    this.henviserEditMode = true;
  }

  isServiceaftaleTerminated() {
    return this.serviceaftale.serviceaftaleState.state == ServiceaftaleStateEnum.Terminated;
  }

  isServiceaftalePendingTermination(): boolean {
    return this.serviceaftale.serviceaftaleState.state == ServiceaftaleStateEnum.ActivePendingTermination;
  }

  isServiceaftaleTerminatedOrPendingTermination(): boolean {
    return this.serviceAftaleStateService.isServiceaftaleTerminatedOrPendingTermination(this.serviceaftale);
  }

  canServiceaftaleBeReactivated(): boolean {
    return this.serviceAftaleStateService.canServiceaftaleBeReactivated(this.serviceaftale);
  }

  editOpkraevningsInterval() {
    if (new Date(this.serviceaftale.startDate) > new Date()) {
      this.openOpkraevningsIntervalDialog(ChangeEffect.Instant);
      return;
    }

    let data: EditTilvalgDialogData = {
      serviceaftale: this.serviceaftale,
      overskrift: 'Hvordan vil du skifte opkrævningsinterval?',
      buttonTekst: 'Skift opkrævningsinterval',
      allowInstantChange: this.serviceaftale.currentServiceinterval?.opkraevningState == OpkraevningStateEnum.NotOpkraevet,
    };

    let dialogRef = this.dialog.open(EditServiceabonnementTilvalgDialogComponent, {
      width: '600px',
      maxWidth: '95vw',
      data: data,
    });

    dialogRef.afterClosed().subscribe((validFrom) => {
      if (validFrom) {
        var today = new Date();
        var isToday = today.toDateString() == new Date(validFrom).toDateString();
        this.openOpkraevningsIntervalDialog(isToday ? ChangeEffect.Instant : ChangeEffect.NextInterval);
      }
    });
  }

  openOpkraevningsIntervalDialog(changeEffect: ChangeEffect) {
    let data: OpkraevningsDialogData = {
      serviceaftale: this.serviceaftale,
      changeEffect: changeEffect,
      opkraevningsInterval: this.serviceaftale.effectiveOpkraevningsinterval,
      opkraevningDate: new Date(this.serviceaftale.opkraevningDate),
    };

    const dialogRef = this.dialog.open(OpkraevningsIntervalDialogComponent, {
      data: data,
    });

    dialogRef.afterClosed().subscribe((result: OpkraevningsDialogResponse) => {
      if (result) {
        const request: UpdateOpkraevningsintervalRequest = {
          serviceaftaleId: this.serviceaftale.id,
          months: result.opkraevningsInterval,
          changeEffect: result.changeEffect,
          opkraevningDate: this.serviceaftale.opkraevningDate,
          rowVersion: this.serviceaftale.rowVersion,
        };
        this.loader.show();
        this.serviceAftaleService
          .updateOpkraevningsinterval({
            caller: EGIS_SERVICE_CALLER,
            body: request,
          })
          .pipe(
            finalize(() => {
              this.loader.hide();
            }),
            takeUntil(this.unsubscribe$),
          )
          .subscribe(
            () => {},
            (error) => {
              this.errorHandler.HandleError(error);
            },
          );
      }
    });
  }
  priceInfo() {
    const data: PriceDialogData = {
      pricecomponents: this.priceComponents,
      moms: !this.pricesWithoutMoms,
      totalPrice: this.totalPrice,
      listPrice: this.listPrice,
      opkraevning: this.opkraevning,
    };
    this.dialog.open(PriceDialogComponent, {
      width: '600px',
      maxWidth: '95vw',
      data: data,
    });
  }

  showUpcomingChanges() {
    const data: UpcomingChangesDialogData = {
      serviceaftale: this.serviceaftale,
      upcomingChanges: this.upcomingChanges,
    };
    const ref = this.dialog.open(UpcomingChangesDialogComponent, {
      data: data,
      width: '670px',
    });
    const sub = ref.componentInstance.onReloadData.subscribe(() => {
      if (this.serviceaftale.serviceAftaleNo) {
        this.reloadServiceAftale(this.serviceaftale.serviceAftaleNo);
      }
    });
    ref.afterClosed().subscribe({
      next: (res) => {
        if (res) this.upcomingChanges = res;
      },
      error: (err) => {
        this.errorHandler.HandleError(err);
      },
    });
  }

  editAbonnement() {
    if (new Date(this.serviceaftale.startDate) > new Date() || this.serviceaftale.serviceAbonnement.isTilkaldsabonnement) {
      this.router.navigate(['/abonnement/edit', this.serviceaftale.serviceAftaleNo], {
        queryParams: {
          validFrom:
            new Date(this.serviceaftale.startDate) > new Date()
              ? new Date(this.serviceaftale.startDate).toOkDateString()
              : new Date().toOkDateString(),
        },
        state: {
          data: {
            serviceaftale: this.serviceaftale,
          },
        },
      });
      return;
    }

    let data: EditTilvalgDialogData = {
      serviceaftale: this.serviceaftale,
      overskrift: 'Hvordan vil du skifte abonnement?',
      buttonTekst: 'Skift abonnement',
      allowInstantChange: true,
    };

    let dialogRef = this.dialog.open(EditServiceabonnementTilvalgDialogComponent, {
      width: '600px',
      maxWidth: '95vw',
      data: data,
    });

    dialogRef.afterClosed().subscribe((validFrom) => {
      if (validFrom) {
        this.router.navigate(['/abonnement/edit', this.serviceaftale.serviceAftaleNo], {
          queryParams: { validFrom: validFrom },
          state: {
            data: {
              serviceaftale: this.serviceaftale,
            },
          },
        });
      }
    });
  }

  reloadServiceAftale(serviceaftaleNo: number) {
    this.loader.show();
    this.serviceAftaleService
      .getServiceaftaleByNo({ caller: EGIS_SERVICE_CALLER, serviceaftaleNo: serviceaftaleNo })
      .pipe(
        finalize(() => {
          this.loader.hide();
        }),
        takeUntil(this.unsubscribe$),
      )
      .subscribe(
        (result: ServiceaftaleDto) => {
          this.serviceaftale = result;
          this.serviceaftaleChanged.emit(result);
        },
        (error) => {
          this.errorHandler.HandleError(error);
        },
      );
  }

  openPartnerInfo() {
    this.loader.show();
    this.serviceAftaleService
      .getPartnerInfoForServiceaftale({ serviceaftaleId: this.serviceaftale.id, caller: EGIS_SERVICE_CALLER })
      .subscribe(
        (partnerInfo) => {
          this.loader.hide();
          this.dialog.open(PartnerDialogComponent, {
            data: partnerInfo,
          });
        },
        (error: HttpErrorResponse) => {
          this.loader.hide();
          this.errorHandler.HandleError(error);
        },
      );
  }

  canEditStartDato() {
    if (this.serviceaftale.serviceaftaleState.state == ServiceaftaleStateEnum.CreatedPending) return true;
    if (
      this.serviceaftale.serviceaftaleState.state == ServiceaftaleStateEnum.Active &&
      this.serviceaftale.serviceintervaller.length <= 1 &&
      this.serviceaftale.currentServiceinterval.eftersynState.eftersynState == EftersynStateEnum.NotCreated &&
      this.serviceaftale.currentServiceinterval.opkraevningState == OpkraevningStateEnum.NotOpkraevet &&
      (this.isAdmin || this.isCustomerService || this.isSuperUser)
    )
      return true;
    return false;
  }
}
